import { orderBy } from 'lodash';

import { IVouchers } from '@epi-models/containers/OrderAmount';

import createReducer from '../../helpers/CreateReducer';
import { ApiConstants } from '../../constants/actions';

interface VouchersState {
  vouchers: IVouchers[];
  filteredVouchers: IVouchers[];
  isLoading: boolean;
  loaded: boolean;
  noPersistance: boolean;
  isError?: boolean;
}

export const getInitialState = (): VouchersState => ({
  vouchers: [],
  filteredVouchers: [],
  isLoading: false,
  loaded: false,
  noPersistance: true
});

export default createReducer(getInitialState, {
  [`${ApiConstants.LOAD_VOUCHERS}_REQUEST`]: (): Partial<VouchersState> => ({
    isLoading: true
  }),

  [`${ApiConstants.LOAD_VOUCHERS}_SUCCESS`]: (
    state: VouchersState,
    { payload: { vouchers } }: { payload: { vouchers: IVouchers[] } }
  ): Partial<VouchersState> => {
    const mappedVouchers = vouchers.map(item => ({
      ...item,
      value: item.value
    }));
    const sortedVouchers = orderBy(mappedVouchers, item => item.value, 'desc');

    return {
      vouchers: sortedVouchers,
      loaded: true,
      isLoading: false
    };
  },

  [`${ApiConstants.LOAD_VOUCHERS}_FAILURE`]: (
    state: VouchersState
  ): Partial<VouchersState> =>
    !state.isError
      ? {
          isLoading: false,
          loaded: true,
          vouchers: [],
          isError: true
        }
      : state
});
